import {
  collection,
  doc,
  getCountFromServer,
  setDoc,
  addDoc,
  getDoc,
  getDocs,
  query,
  or,
  where,
  deleteDoc,
  orderBy,
} from "firebase/firestore";
import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytes,
  uploadString,
} from "firebase/storage";
import { db, storage } from "../firebase/config";
import {
  admissions,
  admittedStudents,
  attendanceInfo,
  buildings,
  classTime,
  classes,
  classrooms,
  configs,
  deletedClassInfo,
  divisions,
  lessons,
  lessonsArray,
  levels,
  sosInfo,
  staff,
  students,
} from "./const";

/* =======================================Logged In User Data============================================================================== */
export const getUserData = async (uid) => {
  try {
    if (!uid) {
      return { error: true, message: "No Uid Provided" };
    }
    const docRef = doc(db, staff, uid);
    const data = await getDoc(docRef);
    if (data.exists()) {
      return { error: false, userData: data.data() };
    } else {
      return { error: true, message: "No Data Found" };
    }
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* =======================================Student Data Interaction========================================================================= */

export const fetchStudents = async () => {
  try {
    const collRef = collection(db, students);
    // const q = query(collRef, where("archived", "!=", true));
    let data = await getDocs(collRef);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    data = data?.filter((e) => {
      if (e?.archived) {
        return false;
      }
      return true;
    });
    // let temp = Array.from(data)?.map(
    //   async (e) => await unArchiveStudentData(e)
    // );
    // await Promise.all(temp);
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};
export const fetchArchivedStudents = async () => {
  try {
    const collRef = collection(db, students);
    const q = query(collRef, where("archived", "==", true));
    let data = await getDocs(q);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const createStudentData = async (data) => {
  try {
    const docRef = doc(db, students, data.id);
    const res = await getDoc(docRef);
    if (res.exists()) {
      return { error: true, message: "Student Id already exists" };
    }
    const count = await getTotalStudents();
    if (!count.error) {
      const docRef = doc(db, configs, "studentCount");
      await setDoc(
        docRef,
        { count: Number(count?.data?.count ?? 0) + 1, date: new Date() },
        { merge: true }
      );
    }

    await setDoc(docRef, data);
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateStudentData = async (data) => {
  try {
    // console.log({ data });
    const docRef = doc(db, students, data.id);
    await setDoc(docRef, { ...data }, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getTotalStudents = async () => {
  try {
    const docRef = doc(db, configs, "studentCount");
    const data = await getDoc(docRef);
    return { error: false, data: data.data() };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateStudentCount = async (data) => {
  try {
    const docRef = doc(db, configs, "studentCount");
    await setDoc(docRef, { count: data, date: new Date() }, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getStudentCount = async () => {
  try {
    const collRef = collection(db, students);
    // const q = query(collRef, where("archived", "!=", true));
    const data = await getCountFromServer(collRef);
    return { error: false, data: data.data().count };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getStudentCountOfDivision = async (classCodes) => {
  try {
    const collRef = collection(db, students);
    const q = query(
      collRef,
      or(
        where("droppedClassCode", "array-contains-any", classCodes),
        where("classCode", "array-contains-any", classCodes)
      )
    );
    // const q2 = query(q, where("archived", "!=", true));
    const data = await getCountFromServer(q);
    return { error: false, data: data.data().count };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};
export const getStudentCountOfClassCode = async (classCode) => {
  try {
    const collRef = collection(db, students);
    const q = query(
      collRef,
      or(
        where("droppedClassCode", "array-contains", classCode),
        where("classCode", "array-contains", classCode)
      )
    );
    // const q2 = query(q, where("archived", "!=", true));
    const data = await getCountFromServer(q);
    return { error: false, data: data.data().count };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};
export const getStudentCountOfClassCodeWithoutDropped = async (classCode) => {
  try {
    const collRef = collection(db, students);
    const q = query(collRef, where("classCode", "array-contains", classCode));
    // const q2 = query(q, where("archived", "!=", true));
    const data = await getCountFromServer(q);
    return { error: false, data: data.data().count };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getStudentData = async (id) => {
  try {
    const docRef = doc(db, students, id);
    let data = await getDoc(docRef);
    return { error: false, data: data.data() };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getSiblingRecords = async (data) => {
  try {
    // let startD = 0;
    if (!data?.id) {
      return { error: true, message: "student id is required" };
    }
    if (!data?.pPhone && !data?.mPhone) {
      return { error: false, data: [] };
    }
    const colRef = collection(db, students);
    const pPhone = data?.pPhone ? data?.pPhone : Date.now();
    const mPhone = data?.mPhone ? data?.mPhone : Date.now();
    const fatherQ = query(
      colRef,
      or(where("pPhone", "==", pPhone), where("mPhone", "==", mPhone))
    );
    // const q = query(fatherQ, where("archived", "!=", true));
    let snap = await getDocs(fatherQ);
    snap = snap?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    snap = snap?.filter((e) => {
      return e.id !== data?.id;
    });
    return { error: false, data: snap };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

// export const archiveStudentData = async (data) => {
//   try {
//     if (!data?.id) {
//       return { error: true, message: "student id is required" };
//     }
//     console.log({ data });
//     let classes = [...data?.classCode, ...data?.droppedClassCode];
//     console.log({ classes });
//     let archiveClassRes = classes?.map((e) => {
//       return deleteStudentFromClass(
//         { studentId: data?.id, classId: e },
//         { droppedReason: "Archiving Student" },
//         data
//       );
//     });
//     archiveClassRes = await Promise.all(archiveClassRes);
//     console.log({ archiveClassRes });
//     return { error: false };
//   } catch (e) {
//     console.log(e);
//     return { error: true, message: e.message };
//   }
// };

export const deleteStudentData = async (data) => {
  try {
    if (!data?.id) {
      return { error: true, message: "student id is required" };
    }
    // console.log({ data });
    let classes = [
      ...(data?.classCode ?? []),
      ...(data?.droppedClassCode ?? []),
    ];
    // console.log({ classes });
    const date = new Date();
    let deleteClassRes = classes?.map(async (e) => {
      const docRef = `${admissions}/${e}/${admittedStudents}/${data.id}`;
      const admissionDocRef = doc(db, docRef);
      const attendanceRes = await getIndividualClassAttendance(
        e,
        data?.id,
        0,
        Number(date?.getFullYear()) - 10
      );
      attendanceRes?.data?.forEach(async (e) => {
        const ref = doc(db, attendanceInfo, e?.id);
        await deleteDoc(ref);
      });
      return await deleteDoc(admissionDocRef);
    });
    deleteClassRes = await Promise.all(deleteClassRes);
    const studentDocRef = doc(db, students, data.id);
    const sosColRef = collection(db, sosInfo);
    const q = query(sosColRef, where("studentId", "==", data?.id));
    const sosDocs = await getDocs(q);
    sosDocs?.docs?.forEach(async (e) => {
      const sosColRef = doc(db, sosInfo, e?.id);
      await deleteDoc(sosColRef);
    });
    await deleteFromStorage("student/qr", data?.id);
    await deleteFromStorage("student/image", data?.id);
    await deleteFromStorage("student/father", data?.id);
    await deleteFromStorage("student/mother", data?.id);
    await deleteDoc(studentDocRef);
    // console.log({ deleteClassRes });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const archiveStudentData = async (data) => {
  try {
    if (!data?.id) {
      return { error: true, message: "student id is required" };
    }
    // console.log({ data });
    let classes = [
      ...(data?.classCode ?? []),
      ...(data?.droppedClassCode ?? []),
    ];
    // console.log({ classes });
    const date = new Date();
    const archiveStatus = { archived: true, archiveDate: date };
    let deleteClassRes = classes?.map(async (e) => {
      const docRef = `${admissions}/${e}/${admittedStudents}/${data.id}`;
      const admissionDocRef = doc(db, docRef);
      const attendanceRes = await getIndividualClassAttendance(
        e,
        data?.id,
        0,
        Number(date?.getFullYear()) - 10
      );
      attendanceRes?.data?.forEach(async (e) => {
        const ref = doc(db, attendanceInfo, e?.id);
        await setDoc(ref, archiveStatus, { merge: true });
      });
      await setDoc(admissionDocRef, archiveStatus, { merge: true });
    });
    deleteClassRes = await Promise.all(deleteClassRes);
    const studentDocRef = doc(db, students, data.id);
    const sosColRef = collection(db, sosInfo);
    const q = query(sosColRef, where("studentId", "==", data?.id));
    const sosDocs = await getDocs(q);
    sosDocs?.docs?.forEach(async (e) => {
      const sosColRef = doc(db, sosInfo, e?.id);
      await setDoc(sosColRef, archiveStatus, { merge: true });
    });

    await setDoc(studentDocRef, archiveStatus, { merge: true });
    // console.log({ deleteClassRes });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const unArchiveStudentData = async (data) => {
  try {
    if (!data?.id) {
      return { error: true, message: "student id is required" };
    }
    // console.log({ data });
    let classes = [
      ...(data?.classCode ?? []),
      ...(data?.droppedClassCode ?? []),
    ];
    // console.log({ classes });
    const date = new Date();
    const archiveStatus = { archived: false, archiveDate: date };
    let deleteClassRes = classes?.map(async (e) => {
      const docRef = `${admissions}/${e}/${admittedStudents}/${data.id}`;
      const admissionDocRef = doc(db, docRef);
      const attendanceRes = await getIndividualClassAttendance(
        e,
        data?.id,
        0,
        Number(date?.getFullYear()) - 10
      );
      attendanceRes?.data?.forEach(async (e) => {
        const ref = doc(db, attendanceInfo, e?.id);
        await setDoc(ref, archiveStatus, { merge: true });
      });
      await setDoc(admissionDocRef, archiveStatus, { merge: true });
    });
    deleteClassRes = await Promise.all(deleteClassRes);
    const studentDocRef = doc(db, students, data.id);
    const sosColRef = collection(db, sosInfo);
    const q = query(sosColRef, where("studentId", "==", data?.id));
    const sosDocs = await getDocs(q);
    sosDocs?.docs?.forEach(async (e) => {
      const sosColRef = doc(db, sosInfo, e?.id);
      await setDoc(sosColRef, archiveStatus, { merge: true });
    });

    await setDoc(studentDocRef, archiveStatus, { merge: true });
    // console.log({ deleteClassRes });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Storage Interaction=========================================================================== */

export const uploadBase64 = async (data, path, file) => {
  try {
    const storageRef = ref(storage, `${path}/${data.id}`);
    // const res = await uploadBytes(storageRef, file);
    const metadata = {
      contentType: "image/png",
    };
    await uploadString(storageRef, file, "data_url", metadata);
    // console.log({ StorageRes: res });
    // console.log({ file });
    const downloadUrl = await getDownloadURL(storageRef);
    // console.log({ downloadUrl });
    return { error: false, data: downloadUrl };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const uploadPhoto = async (data, type, file) => {
  try {
    const storageRef = ref(storage, `${type}/${data.id}`);
    await uploadBytes(storageRef, file);
    // console.log({ StorageRes: res });
    const downloadUrl = await getDownloadURL(storageRef);
    // console.log({ downloadUrl });
    return { error: false, data: downloadUrl };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteFromStorage = async (path, file) => {
  try {
    const storageRef = ref(storage, `${path}/${file}`);
    await deleteObject(storageRef);
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Division Data Interaction========================================================================= */

export const fetchDivisions = async () => {
  try {
    const collRef = collection(db, divisions);
    let data = await getDocs(collRef);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const createDivision = async (data) => {
  try {
    const collRef = collection(db, divisions);
    const res = await addDoc(collRef, data);
    return { error: false, data: res };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateDivision = async (data) => {
  try {
    if (!data.id) {
      return { error: true, message: "Id not found" };
    }
    const docRef = doc(db, divisions, data.id);
    const res = await setDoc(docRef, data, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteDivision = async (id) => {
  try {
    if (!id) {
      return { error: true, message: "Division is required" };
    }
    const docRef = collection(db, classes);
    const q = query(docRef, where("division", "==", id));
    const classRes = await getDocs(q);
    // console.log({ classRes });
    // console.log({ empty: classRes.empty });
    if (!classRes.empty) {
      return { error: true, message: "Delete not allowed" };
    }
    const collRef = doc(db, divisions, id);
    const res = await deleteDoc(collRef);
    // console.log({ res });
    return { error: false, data: res };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Teacher Data Interaction========================================================================= */

export const fetchTeacherData = async () => {
  try {
    const collRef = collection(db, staff);
    const q = query(collRef, where("role", "==", "teacher"));
    let data = await getDocs(q);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const createOrUpdateTeacherData = async (data, uid) => {
  try {
    if (!uid) {
      return { error: true, message: "Invalid UID" };
    }
    const collRef = doc(db, staff, uid);
    await setDoc(collRef, data, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteTeacherData = async (uid) => {
  try {
    const colRef = collection(db, classes);
    let q = query(colRef, where("teacher", "==", uid));
    let classRes = await getDocs(q);
    if (!classRes.empty) {
      return { error: true, message: "Delete not allowed" };
    }
    q = query(colRef, where("asstTeacher", "==", uid));
    classRes = await getDocs(q);
    if (!classRes.empty) {
      return { error: true, message: "Delete not allowed" };
    }
    const docRef = doc(db, staff, uid);
    const storageRes = await deleteFromStorage("teacher/image", uid);
    const res = await deleteDoc(docRef);
    return { error: false, data: res };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Levels Data Interaction========================================================================= */

export const getLevels = async () => {
  try {
    const collRef = collection(db, levels);
    let data = await getDocs(collRef);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const createLevel = async (data) => {
  try {
    const collRef = collection(db, levels);
    const res = await addDoc(collRef, data);
    return { error: false, data: res };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateLevel = async (data) => {
  try {
    const docRef = doc(db, levels, data.id);
    await setDoc(docRef, data, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteLevel = async (id) => {
  try {
    if (!id) {
      return { error: true, message: "Level is required" };
    }
    const dataDocRef = collection(db, classes);
    const q = query(dataDocRef, where("level", "==", id));
    const classRes = await getDocs(q);
    // console.log({ classRes });
    // console.log({ empty: classRes.empty });
    if (!classRes.empty) {
      return { error: true, message: "Delete not allowed" };
    }
    const docRef = doc(db, levels, id);
    const res = await deleteDoc(docRef);
    // console.log({ res });
    return { error: false, data: res };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Buildings Data Interaction======================================================================= */

export const getBuildings = async () => {
  try {
    const collRef = collection(db, buildings);
    let data = await getDocs(collRef);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const createBuilding = async (data) => {
  try {
    const collRef = collection(db, buildings);
    const res = await addDoc(collRef, data);
    return { error: false, data: res };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateBuilding = async (data) => {
  try {
    const docRef = doc(db, buildings, data.id);
    await setDoc(docRef, data, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteBuilding = async (id) => {
  try {
    if (!id) {
      return { error: true, message: "Building is required" };
    }
    const dataDocRef = collection(db, classrooms);
    const q = query(dataDocRef, where("buildingId", "==", id));
    const classRes = await getDocs(q);
    // console.log({ classRes });
    // console.log({ empty: classRes.empty });
    if (!classRes.empty) {
      return { error: true, message: "Delete not allowed" };
    }
    const docRef = doc(db, buildings, id);
    await deleteDoc(docRef);
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Classroom Data Interaction======================================================================= */

export const getAllClassrooms = async () => {
  try {
    const colRef = collection(db, classrooms);
    let data = await getDocs(colRef);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getClassrooms = async (id) => {
  try {
    const colRef = collection(db, classrooms);
    const q = query(colRef, where("buildingId", "==", id));
    let data = await getDocs(q);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const createClassroom = async (data) => {
  try {
    if (!data.buildingId) {
      return { error: true, message: "Building is required" };
    }
    const collRef = collection(db, classrooms);
    const res = await addDoc(collRef, data);
    return { error: false, data: res };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateClassroom = async (data) => {
  try {
    const docRef = doc(db, classrooms, data.id);
    await setDoc(docRef, data, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteClassroom = async (id) => {
  try {
    if (!id) {
      return { error: true, message: "Classroom is required" };
    }
    const dataDocRef = collection(db, classes);
    const q = query(dataDocRef, where("classroom", "==", id));
    const classRes = await getDocs(q);
    // console.log({ classRes });
    // console.log({ empty: classRes.empty });
    if (!classRes.empty) {
      return { error: true, message: "Delete not allowed" };
    }
    const docRef = doc(db, classrooms, id);
    await deleteDoc(docRef);
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Class Time Data Interaction==================================================================== */

export const getAllClassTimings = async () => {
  try {
    const colRef = collection(db, classTime);
    let data = await getDocs(colRef);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

// export const getClassTiming = async (id) => {
//   try {
//     const colRef = collection(db, classTime);
//     const q = query(colRef, where("buildingId", "==", id));
//     let data = await getDocs(q);
//     data = data?.docs?.map((e) => {
//       return { ...e.data(), id: e.id };
//     });
//     // console.log({ data });
//     return { error: false, data: data };
//   } catch (e) {
//     console.log(e);
//     return { error: true, message: e.message };
//   }
// };

export const createClassTiming = async (data) => {
  try {
    if (
      data.day == "default" ||
      data.hours == "default" ||
      data.min == "default" ||
      data.meridiem == "default"
    ) {
      return { error: true, message: "Day and time is required" };
    }
    const collRef = collection(db, classTime);
    const q = query(collRef, where("displayName", "==", data?.displayName));
    const qData = await getDocs(q);
    if (!qData.empty) {
      return { error: true, message: "Timing Already Exists" };
    }
    const res = await addDoc(collRef, data);
    return { error: false, data: res };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateClassTiming = async (data, oldData) => {
  try {
    if (!data.id) {
      return { error: true, message: "Id is required" };
    }
    // const dataDocRef = collection(db, classes);
    // const q = query(
    //   dataDocRef,
    //   where("classTimeFrom", "==", oldData?.displayName)
    // );
    // const classRes = await getDocs(q);
    // // console.log({ classRes });
    // // console.log({ empty: classRes.empty });
    // if (!classRes.empty) {
    //   return { error: true, message: "Update not allowed" };
    // }
    const docRef = doc(db, classTime, data.id);
    const res = await setDoc(docRef, data, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteClassTiming = async (data) => {
  try {
    if (!data?.id) {
      return { error: true, message: "Classroom is required" };
    }
    const dataDocRef = collection(db, classes);
    const q = query(
      dataDocRef,
      where("classTimeFrom", "==", data?.displayName)
    );
    const classRes = await getDocs(q);
    // console.log({ classRes });
    // console.log({ empty: classRes.empty });
    if (!classRes.empty) {
      return { error: true, message: "Delete not allowed" };
    }
    const docRef = doc(db, classTime, data?.id);
    await deleteDoc(docRef);
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Class Data Interaction======================================================================= */

export const createClass = async (data) => {
  try {
    if (!data.classCode) {
      return { error: true, message: "Please fill all the fields" };
    }
    if (!data.module1 && !data.module2 && !data.module3 && !data.module4) {
      return { error: true, message: "At least One module required" };
    }
    const docRef = doc(db, classes, data.classCode);
    const res = await getDoc(docRef);
    if (res.exists()) {
      return { error: true, message: "Class Code Already Used Previously" };
    }
    await setDoc(docRef, { ...data }, { merge: true });
    lessonsArray.forEach(async (e, index) => {
      await createLesson({
        classId: data.classCode,
        seq: index,
        name: e,
        id: e,
      });
    });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateClass = async (data) => {
  try {
    if (!data.id) {
      return { error: true, message: "Please fill all the fields" };
    }
    // const checkDocRef = doc(db, classes, data.classCode);
    // const res = await getDoc(checkDocRef);
    // if (res.exists()) {
    //   return { error: true, message: "Class Code Already Used Previously" };
    // }
    const docRef = doc(db, classes, data.id);
    await setDoc(docRef, { ...data }, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteClass = async (id) => {
  try {
    if (!id) {
      return { error: true, message: "Please fill all the fields" };
    }
    const colRef = collection(db, students);
    const q = query(colRef, where("classCode", "array-contains", id));
    const classRes = await getDocs(q);
    // console.log({ classRes });
    // console.log({ empty: classRes.empty });
    if (!classRes.empty) {
      return { error: true, message: "Delete not allowed" };
    }
    const docRef = doc(db, classes, id);
    await deleteDoc(docRef);
    lessonsArray.forEach(async (e, index) => {
      await deleteLesson({ classId: id, seq: index, name: e, id: e });
    });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getAllClass = async () => {
  try {
    const colRef = collection(db, classes);
    let data = await getDocs(colRef);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getClasses = async (id) => {
  try {
    if (!id) {
      return { error: true, message: "Division Missing" };
    }
    const colRef = collection(db, classes);
    const q = query(
      colRef,
      where("division", "==", id),
      where("upgraded", "==", false)
    );
    let data = await getDocs(q);
    data = data?.docs?.map(async (e) => {
      const studentCount = await getStudentCountOfClassCodeWithoutDropped(e.id);
      return { ...e.data(), id: e.id, numberOfStudents: studentCount?.data };
    });
    const promisedData = await Promise.all(data);
    // console.log({ promisedData });
    return { error: false, data: promisedData };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getHistoricalClasses = async (id) => {
  try {
    if (!id) {
      return { error: true, message: "Division Missing" };
    }
    const colRef = collection(db, classes);
    const q = query(
      colRef,
      where("division", "==", id),
      where("upgraded", "==", true)
    );
    let data = await getDocs(q);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getClassesViaTeacher = async (id) => {
  try {
    if (!id) {
      return { error: true, message: "Division Missing" };
    }
    const colRef = collection(db, classes);
    const q = query(colRef, where("teacher", "==", id));
    let data = await getDocs(q);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getClass = async (id) => {
  try {
    const docRef = doc(db, classes, id);
    let data = await getDoc(docRef);
    return { error: false, data: data.data() };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const upgradeClass = async (oldData, newData, lessonName) => {
  try {
    if (!newData.level) {
      return { error: true, message: "Level is required" };
    }
    if (oldData.level === newData.level) {
      return { error: true, message: "Level cannot be same" };
    }
    // console.log({ oldData });
    // console.log({ newData });
    const year = Number(oldData.intakeYear) + 1;
    let classId = oldData.id;
    let modifyValue = oldData.id.split("(")[1].split(")")[0];
    let levelModify = modifyValue.split("-")[0];
    let yearModify = modifyValue.split("'")[1];
    classId = classId.replace(levelModify, lessonName);
    classId = classId.replace(yearModify, year.toString().slice(-2));
    // console.log(classId);
    // if (Number(yearModify) > 0) {
    //   return { error: true };
    // }
    const createClassRes = await createClass({
      ...newData,
      intakeYear: year,
      classCode: classId,
    });

    // console.log(createClassRes);
    if (createClassRes.error) {
      return { error: true, message: createClassRes.message };
    }
    const admissionData = await fetchStudentAdmissionsData(oldData.id);
    // console.log({ admissionData });
    if (admissionData.error) {
      return { error: true, message: admissionData.message };
    }
    let admissionDataCompletion = admissionData?.data?.map(async (e) => {
      let date = new Date();
      let enrollData = {
        division: newData.division,
        level: newData.level,
        studentId: e.id,
        classId: classId,
        admissionDate: `${date.getFullYear()}-${date.getMonth()}-${date.getUTCDate()}`,
        paymentStatus: false,
        message: "",
        dropped: false,
        paidAmount: "",
        droppedDate: "",
        droppedReason: "",
        paymentDurationStart: "",
        paymentDurationEnd: "",
      };
      console.log({ enrollData });
      return await enrollStudentToClass(enrollData);
    });
    let err = false;
    let processedEnrollData = await Promise.all(admissionDataCompletion);
    processedEnrollData.forEach((e) => {
      if (e.error) {
        err = true;
      }
    });
    if (err) {
      return {
        error: true,
        message: "something went wrong while enroll student to new class",
      };
    }
    // const newClassId = oldData.id.split(-)
    await updateClass({ id: oldData.id, upgraded: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Lessons Data Interaction======================================================================= */

export const getLessons = async (id) => {
  try {
    const colRef = collection(db, classes + "/" + id + "/" + lessons);
    const q = query(colRef, orderBy("seq"));
    let data = await getDocs(q);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    // console.log({ data });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const createLesson = async (data) => {
  try {
    if (!data.name) {
      return { error: true, message: "Please enter lesson name" };
    }
    const docRef = doc(
      db,
      classes + "/" + data.classId + "/" + lessons,
      data.name
    );
    const res = await getDoc(docRef);
    if (res.exists()) {
      return { error: true, message: "Lesson already exists for this class" };
    }
    await setDoc(docRef, { ...data }, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const restoreLesson = async (classCode) => {
  try {
    // if (!data.name) {
    //   return { error: true, message: "Please enter lesson name" };
    // }
    // const docRef = doc(
    //   db,
    //   classes + "/" + data.classId + "/" + lessons,
    //   data.name
    // );
    // const res = await getDoc(docRef);
    // if (res.exists()) {
    //   return { error: true, message: "Lesson already exists for this class" };
    // }
    // await setDoc(docRef, { ...data }, { merge: true });
    // return { error: false };
    let temp = lessonsArray.map(async (e, index) => {
      return await createLesson({
        classId: classCode,
        seq: index,
        name: e,
        id: e,
      });
    });

    temp = await Promise.all(temp);
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateLesson = async (data) => {
  try {
    const docRef = doc(
      db,
      classes + "/" + data.classId + "/" + lessons,
      data.id
    );
    await setDoc(docRef, { ...data }, { merge: true });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteLesson = async (data) => {
  try {
    const docRef = doc(
      db,
      classes + "/" + data.classId + "/" + lessons,
      data.id
    );
    const res = await deleteDoc(docRef);
    return { error: false, data: res };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Admission Data Interaction======================================================================= */

export const getAdmissionData = async (classId, studentId) => {
  try {
    const ref = `${admissions}/${classId}/${admittedStudents}/${studentId}`;
    const admissionDocRef = doc(db, ref);
    let data = await getDoc(admissionDocRef);
    return { error: false, data: data.data() };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const fetchStudentAdmissionsData = async (classId) => {
  try {
    const ref = `${admissions}/${classId}/${admittedStudents}`;
    const collRef = collection(db, ref);
    // const q = query(collRef, where("dropped", "!=", true));
    let data = await getDocs(collRef);
    data = data?.docs.map((e) => {
      return { ...e.data(), id: e.id };
    });
    data = data?.filter((e) => {
      if (e?.archived) {
        return false;
      }
      return true;
    });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};
export const fetchHistoricalStudentAdmissionsData = async (classId) => {
  try {
    const ref = `${admissions}/${classId}/${admittedStudents}`;
    const collRef = collection(db, ref);
    let data = await getDocs(collRef);
    data = data?.docs.map((e) => {
      return { ...e.data(), id: e.id };
    });
    data = data?.filter((e) => {
      if (e?.archived) {
        return false;
      }
      return true;
    });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const enrollStudentToClass = async (data) => {
  try {
    if (!data.studentId) {
      return { error: true, message: "Invalid Student Id" };
    }
    const studentDocRef = doc(db, students, data.studentId);
    // console.log({ studentDocRef });
    const studentDoc = await getDoc(studentDocRef);
    if (!studentDoc.exists) {
      return { error: true, message: "Student Data Not Found" };
    }
    const studentData = studentDoc.data();
    // console.log({ studentData });
    //getting current classes
    let classCode = studentData.classCode;
    let droppedClassCode = studentData.droppedClassCode;
    //checking if user already in same class
    if (classCode.includes(data?.classId)) {
      return { error: true, message: "Student Already In Class" };
    }
    //removing user if dropped
    droppedClassCode = droppedClassCode.filter((e) => {
      return e !== data?.classId;
    });
    // extra check to have unique classCode
    classCode = [...new Set([...classCode, data?.classId])];
    const ref = `${admissions}/${data.classId}/${admittedStudents}/${data.studentId}`;
    const admissionDocRef = doc(db, ref);
    //creating new admission
    await setDoc(admissionDocRef, data, { merge: true });
    //setting data in user document
    await setDoc(
      studentDocRef,
      { classCode, droppedClassCode },
      { merge: true }
    );
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const deleteStudentFromClass = async (data, setData, studentData) => {
  try {
    // if (!setData.droppedReason) {
    //   return { error: true, message: "Please Mention Reason" };
    // }
    const studentDocRef = doc(db, students, data.studentId);
    //getting current classes
    let classCode = studentData.classCode;

    //removing student from the class
    classCode = classCode.filter((e) => {
      return e !== data?.classId;
    });
    //
    const ref = `${admissions}/${data.classId}/${admittedStudents}/${data.studentId}`;
    const admissionDocRef = doc(db, ref);
    //deleting admission
    await deleteDoc(admissionDocRef);
    //setting data in user document
    await setDoc(studentDocRef, { classCode }, { merge: true });
    //create a delete entry
    const deletedDocRef = collection(db, deletedClassInfo);
    await addDoc(deletedDocRef, {
      studentName: studentData?.name,
      studentId: data?.studentId,
      classCode: data?.classId,
      ...setData,
      deletedDate: new Date(),
    });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const withdrawStudentToClass = async (data, setData, studentData) => {
  try {
    if (!setData.droppedReason) {
      return { error: true, message: "Please Mention Reason" };
    }
    // if (!setData.classId) {
    //   return { error: true, message: "Please select a class" };
    // }
    const studentDocRef = doc(db, students, data.studentId);
    //getting current classes
    let classCode = studentData.classCode;
    let droppedClassCode = studentData.droppedClassCode;
    //removing student from the class
    classCode = classCode.filter((e) => {
      return e !== data?.classId;
    });

    // extra check to have unique classCode
    droppedClassCode = [...new Set([...droppedClassCode, data?.classId])];

    const ref = `${admissions}/${data.classId}/${admittedStudents}/${data.studentId}`;
    const admissionDocRef = doc(db, ref);
    //creating new admission
    await setDoc(admissionDocRef, setData, { merge: true });
    //setting data in user document
    await setDoc(
      studentDocRef,
      { classCode, droppedClassCode },
      { merge: true }
    );
    const sosDocRef = collection(db, sosInfo);
    await addDoc(sosDocRef, {
      studentName: studentData?.name,
      studentId: data?.studentId,
      classCode: data?.classId,
      ...setData,
    });
    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateStudentPayment = async (data) => {
  try {
    const ref = `${admissions}/${data.classId}/${admittedStudents}/${data.studentId}`;
    const admissionDocRef = doc(db, ref);
    //creating new admission
    await setDoc(admissionDocRef, data, { merge: true });
    //setting data in user document

    return { error: false };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================SOS Data Interaction======================================================================= */

export const getAllSOSData = async () => {
  try {
    const sosDocRef = collection(db, sosInfo);
    // const q = query(sosDocRef, where("archived", "!=", true));
    let data = await getDocs(sosDocRef);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    data = data?.filter((e) => {
      if (e?.archived) {
        return false;
      }
      return true;
    });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Attendance Data Interaction=================================================================== */

export const getAllClassAttendance = async (id, startD, year) => {
  try {
    // let startD = 0;
    if (!id) {
      return { error: true, message: "ClassId is Required" };
    }
    const colRef = collection(db, attendanceInfo);
    let startDate = new Date(year, startD, 1);
    let endDate = new Date(year, startD + 3);
    // console.log({ startDate });
    // console.log({ endDate });
    const q = query(
      colRef,
      where("classId", "==", id),
      where("date", ">", startDate)
    );
    let data = await getDocs(q);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    data = data?.filter((e) => {
      if (e?.archived) {
        return false;
      }
      return true;
    });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const updateClassAttendance = async (data) => {
  try {
    // let startD = 0;
    // console.log({ data });
    if (!data?.id) {
      return { error: true, message: "id is Required" };
    }
    const docRef = doc(db, attendanceInfo, data?.id);
    delete data.date;
    delete data?.status;
    await setDoc(docRef, data, { merge: true });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const createClassAttendance = async (data) => {
  try {
    // let startD = 0;
    // console.log({ data });
    if (!data?.id) {
      return { error: true, message: "id is Required" };
    }
    const docRef = doc(db, attendanceInfo, data?.id);
    await setDoc(docRef, data, { merge: true });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

export const getIndividualClassAttendance = async (
  classId,
  studentId,
  startD,
  year
) => {
  try {
    // let startD = 0;
    if (!classId) {
      return { error: true, message: "ClassId is Required" };
    }
    const colRef = collection(db, attendanceInfo);
    let startDate = new Date(year, startD, 1);
    // console.log({ startDate });
    const q = query(
      colRef,
      where("classId", "==", classId),
      where("studentId", "==", studentId),
      where("date", ">", startDate)
    );
    let data = await getDocs(q);
    data = data?.docs?.map((e) => {
      return { ...e.data(), id: e.id };
    });
    data = data?.filter((e) => {
      if (e?.archived) {
        return false;
      }
      return true;
    });
    return { error: false, data: data };
  } catch (e) {
    console.log(e);
    return { error: true, message: e.message };
  }
};

/* ==========================================Miscellaneous Interaction=================================================================== */

export const checkSize = (file) => {
  return file.size / 1024 / 1024;
};

export async function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

export async function getCroppedImg(
  imageSrc,
  pixelCrop,
  rotation = 0,
  flip = { horizontal: false, vertical: false }
) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    return null;
  }

  const rotRad = getRadianAngle(rotation);

  // calculate bounding box of the rotated image
  const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
    image.width,
    image.height,
    rotation
  );

  // set canvas size to match the bounding box
  canvas.width = bBoxWidth;
  canvas.height = bBoxHeight;

  // translate canvas context to a central location to allow rotating and flipping around the center
  ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
  ctx.rotate(rotRad);
  ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
  ctx.translate(-image.width / 2, -image.height / 2);

  // draw rotated image
  ctx.drawImage(image, 0, 0);

  // croppedAreaPixels values are bounding box relative
  // extract the cropped image using these values
  const data = ctx.getImageData(
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height
  );

  // set canvas width to final desired crop size - this will clear existing context
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // paste generated rotate image at the top left corner
  ctx.putImageData(data, 0, 0);

  // As Base64 string
  // return canvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file));
    }, "image/jpeg");
  });
}
export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

export function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

/**
 * Returns the new bounding area of a rotated rectangle.
 */

export function rotateSize(width, height, rotation) {
  const rotRad = getRadianAngle(rotation);

  return {
    width:
      Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height:
      Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
  };
}

export function convertBlobToBase64(blobUrl) {
  return new Promise((resolve, reject) => {
    fetch(blobUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Data = reader.result;
          resolve(base64Data);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      })
      .catch(reject);
  });
}
